import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { createPluginState, getPluginState, createInitialState } from './plugin-factory';
import { SafePlugin } from '../local-safe-plugin';
import { aiSpellingGrammarPluginKey } from './ai-spelling-grammar-plugin-key';
import { createTriggerSpellingAndGrammerCheck } from './commands';
export function createAISpellingGrammarPlugin(options) {
  const {
    triggerSpellingAndGrammerCheck,
    cancelDebouncedAndThrottledSpellingAndGrammerCheck
  } = createTriggerSpellingAndGrammerCheck(options.proactiveAIConfig.timings);
  return new SafePlugin({
    key: aiSpellingGrammarPluginKey,
    state: createPluginState(options.dispatch, createInitialState(options.proactiveAIConfig.apiUrl)),
    view() {
      return {
        update: (view, prevState) => {
          const {
            locale
          } = options.getIntl();
          const {
            isSpellingAndGrammarEnabled
          } = getPluginState(view.state);
          if (isSpellingAndGrammarEnabled && (!prevState.doc.eq(view.state.doc) || !prevState.selection.eq(view.state.selection))) {
            triggerSpellingAndGrammerCheck(view, locale);
          }
        },
        destroy: cancelDebouncedAndThrottledSpellingAndGrammerCheck
      };
    },
    props: {
      decorations: state => {
        const {
          isSpellingAndGrammarEnabled,
          decorationSet
        } = getPluginState(state);
        if (!isSpellingAndGrammarEnabled) {
          return DecorationSet.empty;
        }
        return decorationSet;
      },
      attributes: {
        spellcheck: 'false'
      }
    }
  });
}